import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress harmless Cross-Origin-Opener-Policy warnings from Firebase OAuth popups
// These warnings occur because Firebase tries to check if the popup window is closed,
// but COOP policy blocks access to window.closed. This doesn't affect functionality.
// The warnings are harmless and don't prevent OAuth sign-in from working correctly.
const originalError = console.error;
console.error = (...args) => {
  const message = args[0]?.toString() || '';
  // Filter out COOP-related warnings from Firebase OAuth
  if (
    message.includes('Cross-Origin-Opener-Policy') &&
    (message.includes('window.closed') || message.includes('window.close'))
  ) {
    return; // Suppress this warning
  }
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
